import IconDownload from '@src/assets/images/common/icon/chat-action/icon-download.svg';
import CloseFilesIcon from '@src/assets/images/common/icon/files/icon-close-files.svg';
import { fetchIcon } from '@src/enum/chatAttachableFileExtension';
import { useIsMobile } from '@src/hooks/useIsMobile';
import { Attachment } from '@src/idb';
import React, { useEffect, useState } from 'react';

export type PreviewFileItemProps = {
  attachment: Attachment;
  upload?: boolean;
  onDelete?: () => void;
};

const PreviewFileItem: React.FC<PreviewFileItemProps> = ({
  attachment,
  upload = false,
  onDelete,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = useIsMobile();
  const fileName =
    attachment.name ||
    (attachment.chatAttachment && attachment.chatAttachment.file_name) ||
    'unknown';
  const ext =
    fileName.split('.').pop()?.toLowerCase() || attachment.chatAttachment?.extension || '';
  const iconSrc = fetchIcon(ext);
  const [isSending, setSending] = useState<boolean>(false);

  useEffect(() => {
    setSending(attachment.blob instanceof File && !attachment.chatAttachment?.file_url);
  }, [attachment.blob, attachment.chatAttachment]);

  return (
    <div
      className='group/file-download relative flex h-[48px] w-[200px] cursor-pointer items-center gap-[10px] rounded-[4px] border border-solid border-gray-200 p-2'
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className='size-8 shrink-0'>
        <img
          src={iconSrc}
          alt={`${ext}ファイル`}
          className='size-6 shrink-0'
        />
      </div>
      <div className='min-w-0'>
        <p className='truncate font-semibold leading-normal'>{fileName}</p>
        <p className='text-sm leading-none'>.{ext}</p>
      </div>
      {upload && isHover && onDelete && !isMobile && (
        <button
          onClick={onDelete}
          className='absolute right-[2px] top-[2px] size-5 place-items-center rounded-full'
          aria-label='削除'
        >
          <img
            src={CloseFilesIcon}
            alt='削除'
            className='size-4'
          />
        </button>
      )}
      {isSending && (
        <div className='absolute right-1 top-1 size-4 animate-spin rounded-full border-2 border-[#5B8CEC] border-t-transparent'></div>
      )}
      {!upload && isHover && attachment.chatAttachment?.file_url && (
        <a
          href={attachment.chatAttachment.file_url}
          download={fileName}
          className='absolute right-1 top-1 size-10 place-items-center rounded-[4px] bg-white p-1 shadow'
          aria-label='ダウンロード'
        >
          <img
            src={IconDownload}
            alt='ダウンロード'
            className='size-4'
          />
        </a>
      )}
    </div>
  );
};

export default PreviewFileItem;
